import styled from "styled-components"

export default styled.h2`
  font-size: 46px;
  line-height: 56px;
  padding: 37px 0 3px;
  font-weight: 600;
  letter-spacing: -0.01em;
  ${'' /* ${props => props.light && `color: ${props.theme.light.primary}`} */}
`
